import { render } from "./CreatePostView.vue?vue&type=template&id=fe2f111e&scoped=true"
import script from "./CreatePostView.vue?vue&type=script&lang=js"
export * from "./CreatePostView.vue?vue&type=script&lang=js"

import "./CreatePostView.vue?vue&type=style&index=0&id=fe2f111e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2f111e"]])

export default __exports__